import { fg } from '@atlassian/jira-feature-gating';

const isLinkedIssuesEditableSyncLoadedOnInitialLoad = {
	get(): boolean {
		return (
			fg('jira_is_editable_sync_loaded_for_remote_links') &&
			(fg('jira_linked_issues_pagination') || fg('use_node_id_for_row_key'))
		);
	},
};

export default isLinkedIssuesEditableSyncLoadedOnInitialLoad;
